<ion-item>

  <ion-label>
    <div class="data">
      <yu-icon slot="start" name="calendar"></yu-icon>
      <span>{{ date | date: "EEEE, dd MMM yyyy" | titlecase }}</span>
    </div>

    <div class="data">
      <yu-icon slot="start" name="map-pin"></yu-icon>
      <span>{{ local }}</span>
    </div>

    <div class="data">
      <yu-icon slot="start" name="call-bell"></yu-icon>
      <span>{{ service }}</span>
    </div>

    @if (!!user) {
      <div class="data">
        <yu-icon slot="start" name="user"></yu-icon>
        <span>{{ user }}</span>
      </div>
    }
  </ion-label>

</ion-item>
